<div class="row">
  <div class="col-md-12 usrListPos">
    <div class="panel panel-default userListPanel" style="margin-bottom: 0px">
      <div class="panel-body">
        <div [style.width]="'100%'" [style.height]="isBookingLookup ? 'auto' : '500px'">
          <div class="lookup-meta" *ngIf="isBookingLookup && (lookupShipmentXid || lookupCurrentDriverName)">
            <div *ngIf="lookupShipmentXid">
              <span class="meta-label"
                >{{ resourceService.get('lbl_tms_shipment_xid') || 'Shipment ID' }}:</span
              >
              <strong>{{ lookupShipmentXid }}</strong>
            </div>
            <div *ngIf="lookupCurrentDriverName">
              <span class="meta-label"
                >{{ resourceService.get('lbl_tms_current_driver') || 'Current Driver' }}:</span
              >
              <strong>{{ lookupCurrentDriverName }}</strong>
            </div>
          </div>

          <form
            class="form-horizontal"
            role="form"
            [ngClass]="
              isBookingLookup ? 'lookup-form-booking' : 'lookup-form-default'
            "
          >
            <div class="row" *ngIf="!isBookingLookup">
              <label for="name" class="col-sm-2 control-label">{{
                resourceService.get('lbl_tms_driver_name')
              }}</label>
              <div class="col-xs-2 carrier-detail-form-col">
                <input
                  type="text"
                  class="form-control sr-box"
                  id="name"
                  name="name"
                  [(ngModel)]="searchCondition.name"
                  (ngModelChange)="updateFilter()"
                  autocomplete="off"
                />
              </div>
              <label for="phone" class="col-sm-2 control-label">{{
                resourceService.get('lbl_tms_phone')
              }}</label>
              <div class="col-sm-2 carrier-detail-form-col">
                <input
                  type="text"
                  class="form-control sr-box"
                  id="phone"
                  name="phone"
                  (ngModelChange)="updateFilter()"
                  [(ngModel)]="searchCondition.phone"
                  autocomplete="off"
                />
              </div>
            </div>

            <div class="lookup-filter-row" *ngIf="isBookingLookup">
              <div class="lookup-filter-field">
                <label>{{ resourceService.get('lbl_tms_driver_name') }}</label>
                <input
                  type="text"
                  class="form-control sr-box"
                  id="name"
                  name="name"
                  [(ngModel)]="searchCondition.name"
                  (ngModelChange)="updateFilter()"
                  autocomplete="off"
                  [placeholder]="resourceService.get('lbl_tms_driver_name')"
                />
              </div>
              <div class="lookup-filter-field">
                <label>{{ resourceService.get('lbl_tms_truck_number') }}</label>
                <input
                  type="text"
                  class="form-control sr-box"
                  id="carNumber"
                  name="carNumber"
                  [(ngModel)]="searchCondition.carNumber"
                  (ngModelChange)="updateFilter()"
                  autocomplete="off"
                  [placeholder]="resourceService.get('lbl_tms_truck_number')"
                />
              </div>
            </div>
          </form>

          <div class="userlist" [style.margin]="isBookingLookup ? '0' : '0px 20px'">
            <p-table
              [columns]="columnDef"
              [value]="pageInfo.content"
              [(selection)]="selectedRow"
              rowHover="true"
              selectionMode="single"
              [scrollHeight]="isBookingLookup ? '420px' : '240px'"
              resizableColumns="true"
              columnResizeMode="expand"
              reorderableColumns="true"
            >
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <td style="width: 3rem"></td>
                  <th *ngFor="let col of columns">
                    {{ col.elementId }}
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr>
                  <td style="text-align: center">
                    <p-tableRadioButton [value]="rowData"></p-tableRadioButton>
                  </td>
                  <td *ngFor="let col of columns" style="cursor: pointer">
                    <span class="cell-view">{{ rowData[col.propertyName] }}</span>
                  </td>
                </tr>
              </ng-template>
            </p-table>
            <div class="rdt-top-bar lookup-paginator-bar">
              <span class="lookup-results" *ngIf="isBookingLookup">
                {{ pageInfo.totalElements || 0 }}
                {{ resourceService.get('lbl_results_found') || 'Results found' }}
              </span>
              <p-paginator
                #paginator
                [rows]="pageInfo.size"
                [totalRecords]="pageInfo.totalElements"
                [rowsPerPageOptions]="isBookingLookup ? [10, 20, 50, 100] : [5, 10, 20, 50]"
                (onPageChange)="onPageChange($event)"
              ></p-paginator>
            </div>
          </div>

          <div class="text-center">
            <button class="lfwms-btn-default" (click)="onConfirm()">
              {{ resourceService.get('btn_confirm') }}
            </button>
            <button class="lfwms-btn-default" (click)="onCancel()">
              {{ resourceService.get('btn_cancel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
